module.exports = __webpack_public_path__ + "static/img/12.05d54139.png";